import React from 'react';
import { useHistory } from 'react-router-dom';

import routes from 'lane-shared/config/routes';
import { ServiceRequestFeedbackModal } from './ServiceRequestFeedbackModal';
import { FeedbackAlreadySubmittedModal } from './FeedbackAlreadySubmittedModal';

type ServiceRequestFeedback = {
  __typename?: 'ServiceRequestFeedback';
  rating: number;
  comment?: string | null;
  submittedAt: any;
  userId: string;
};

type ServiceRequestFeedbackContainerData = {
  serviceRequestId: string;
  userFriendlyID: string;
  status: string;
  category?: string;
  issue?: string;
};

type ServiceRequestFeedbackContainerProps = {
  serviceRequest: ServiceRequestFeedbackContainerData;
  contentId: string;
  feedback?: ServiceRequestFeedback;
  onFeedbackSubmit?: () => void;
};

export const ServiceRequestFeedbackContainer: React.FC<
  ServiceRequestFeedbackContainerProps
> = ({ serviceRequest, contentId, feedback, onFeedbackSubmit }) => {
  const history = useHistory();
  const [modalOpen, setModalOpen] = React.useState(true);

  const hasFeedback = !!feedback;

  const handleModalClose = () => {
    const serviceRequestDetailUrl = `${routes.content.replace(/:id\b/g, contentId)}?serviceRequestId=${serviceRequest.serviceRequestId}`;

    history.replace(serviceRequestDetailUrl);
    setModalOpen(false);
  };

  const handleFeedbackSubmit = () => {
    onFeedbackSubmit?.();
    handleModalClose();
  };

  if (hasFeedback) {
    return (
      <FeedbackAlreadySubmittedModal
        isOpen={modalOpen}
        onClose={handleModalClose}
      />
    );
  }

  return (
    <ServiceRequestFeedbackModal
      isOpen={modalOpen}
      onClose={handleModalClose}
      onFeedbackSubmit={handleFeedbackSubmit}
      serviceRequest={serviceRequest}
      testId="member-service-request-feedback-modal"
    />
  );
};
